import type {ReactElement} from 'react';
import React from 'react';
import type {FadeBackgroundProps} from './fade-background.types';
import {FadeDirection} from './fade-background.types';
import styles from './fade-background.module.scss';

export function FadeBackground({direction = FadeDirection.LEFT}: FadeBackgroundProps): ReactElement<any> {
  return (
    <div className={`_full-width _full-height ${styles.container}`}>
      <div className={`${styles.mediumContainer} _full-width _full-height`} />
      <div className={`${styles.innerContainer} ${direction === FadeDirection.RIGHT ? styles.rightDirection : ''} _full-width _full-height`} />
    </div>
  );
}
